module.exports = __webpack_public_path__ + "img/LastPost_img.81e88316.png";